import { Dialog } from "./Dialog/Dialog"

export { Dialog }
